import {
    Controller
} from "stimulus"
import ready from '../ready'
import Splide from '@splidejs/splide';

export default class extends Controller {
    static targets = ['prev', 'next']
    splide

    get el()
    {
        return this.data.has('selector')
            ? this.element.querySelector(this.data.get('selector'))
            : this.element
    }

    get config()
    {
        let config = JSON.parse(this.data.get('config'))
        let defaults = {
            on: {
                mounted: () => this.handleMounted(),
            }
        }
        if (this.hasPrevTarget && this.hasNextTarget) {
            defaults['navigation'] = {
                nextEl: this.nextTarget,
                prevEl: this.prevTarget,
            }
        }

        if (!config) {
            return defaults
        }

        return Object.assign(defaults, config)
    }


    /**
     * Dont load the carousel until all the assets (like fonts) are loaded.
     */
    connect()
    {
        if(this.data.get('defer')) {
            ready.then(this.init.bind(this))
        } else {
            this.init()
        }
    }

    init()
    {
        this.splide = new Splide( this.el, this.config );
        this.splide.mount()
    }


    handleMounted()
    {
        this.element.classList.remove('invisible')
    }


    disconnect()
    {
        this.splide.destroy(true)
    }
}